var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import './approval-phases-details.css';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { number, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import ApprovalPhasesDetailsAPI from './approval-phases-details-api';
let ApprovalPhasesDetails = class ApprovalPhasesDetails extends Component {
    render() {
        const { itemName, amount, value, unitType, } = this.props;
        return (React.createElement("div", { className: "approval-item-details" },
            React.createElement("div", { className: "approval-item-details__info" },
                React.createElement("div", { className: "approval-item-card__info-item" }, itemName),
                React.createElement("div", { className: "approval-item-details__info-value" },
                    MessageService.translate('approvals.item.amount'),
                    ": ",
                    amount),
                React.createElement("div", { className: "approval-item-details__info-value" },
                    MessageService.translate('approvals.item.value-unit'),
                    ": ",
                    value),
                React.createElement("div", { className: "approval-item-details__info-value" },
                    MessageService.translate('approvals.item.unit'),
                    ": ",
                    unitType))));
    }
};
ApprovalPhasesDetails.propTypes = {
    itemName: string,
    amount: number,
    value: number,
    unitType: string,
};
ApprovalPhasesDetails = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: ApprovalPhasesDetailsAPI })
], ApprovalPhasesDetails);
export default ApprovalPhasesDetails;
//# sourceMappingURL=approval-phases-details.js.map